export default __webpack_public_path__ + "static/media/Expense.593153ee.png";